import blockIndex from 'actions/block/index';
import eventsIndex from 'actions/events/index';
import pageIndex from 'actions/page/index';
import newsIndex from 'actions/news/index';
import trainingIndex from 'actions/training/index';
import Layout from 'components/Layout';
import Container from 'components/UI/Container';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import Agenda from '../../components/UI/Agenda';
import BottomCards from './components/BottomCards';
import Hero from './components/Hero';
import News from './components/News';
import TopCards from './components/TopCards';
import './index.module.scss';

export default function Home() {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(newsIndex());
        dispatch(blockIndex(null));
        dispatch(pageIndex());
        dispatch(trainingIndex());
        dispatch(eventsIndex());
    }, []);

    return (
        <Layout>
            <Container>
                <Hero />
                <TopCards />
                <div styleName="newsAgenda">
                    <News />
                    <Agenda home />
                </div>
                <BottomCards />
            </Container>
        </Layout>
    );
}
